import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "react-datepicker/dist/react-datepicker.css";
import * as serviceWorker from './serviceWorker';
import LOGO from './assets/logo/app_icon.png';

import { createStore, applyMiddleware, compose } from 'redux';
import { Provider, useSelector } from 'react-redux';
import mainReducer from './store/reducers/mainReducer';
import {
  reduxFirestore,
  getFirestore,
  createFirestoreInstance
} from "redux-firestore";
import {
  ReactReduxFirebaseProvider,
  getFirebase,
  isLoaded
} from "react-redux-firebase";
import firebaseConfig from './config/firebaseConfig';
import firebase from "firebase/app";
import thunk from 'redux-thunk';

import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Loader from 'react-loader-spinner';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';



// Creating store with middleware
const store = createStore(
  mainReducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirestore, getFirebase })),
    reduxFirestore(firebaseConfig)
  )
);
const isTestApp = store.getState().appControl.isTestApp;
const isStradaAccount = true;
console.log(isTestApp)
const stripePromise = loadStripe(
  // strada imaging
  // 'pk_test_51IFPQsBIUqosrDFivcG44UteqGhIbq6TMaDdsxx6mgytMhY2V4dJFrZ4PH6bXcOADzZkIVfJoC7Yr3EEBRndS2ha00RPgxdDyi' // testing
  // 'pk_live_51IFPQsBIUqosrDFieKgPqMSyTnMCw44IWmZAxuQqOKLUvSxYNuMWpUeDd0auBVcpvkaO4w204GZRTD3LnsAtYdj200YYuyW9sN' // production
  // axibuild
  // 'pk_test_51JVJ0MGOQiaX4onHu178pWMRRGnnHWOi7KMM8AlRegtsTRKWcQVBZQY4x0nyOkuAddP1vYU1lcRduXtNNz73UVaL009l1XsGMY' // testing
  // 'pk_live_51JVJ0MGOQiaX4onHIKU1jOuyE4Ma6DqaH7Qv7HWfjpOUGe6Xeb2Fru6qHr1EmgL67Mqe40AgZ2N5P5qO9yQ5NkQ100pglw2MHU' // production

  isTestApp === true ? 'pk_test_51IFPQsBIUqosrDFivcG44UteqGhIbq6TMaDdsxx6mgytMhY2V4dJFrZ4PH6bXcOADzZkIVfJoC7Yr3EEBRndS2ha00RPgxdDyi' :
    'pk_live_51IFPQsBIUqosrDFieKgPqMSyTnMCw44IWmZAxuQqOKLUvSxYNuMWpUeDd0auBVcpvkaO4w204GZRTD3LnsAtYdj200YYuyW9sN'
);

// Adding persistence to store
const persistor = persistStore(store);

// Read user profile from here
const rrfConfig = {
  userProfile: 'Users',
  useFirestoreForProfile: true
}

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};

function AuthIsLoaded({ children }) {
  const auth = useSelector(state => state.firebase.auth)
  if (!isLoaded(auth)) {
    return (
      <div className="d-flex align-items-center min-vh-100 loading-screen">
        <div className="container text-center">
          <img src={LOGO} alt="AssetTag" width="150px" height="auto" />
          <br></br>
          <br></br>
          <h3 style={{ color: '#141414' }}><b>AssetTag</b></h3>
          <br></br>
          <Loader
            type="TailSpin"
            color="#143896"
            height={30}
            width={30}
          />
          <br />
          <p style={{ color: '#141414' }}>A product of <i><u><a href="https://axibuild.com" style={{ color: "#141414" }}>AxiBuild</a></u></i></p>
        </div>
      </div>
    )
  };
  return children
}

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <AuthIsLoaded>
        <PersistGate persistor={persistor}>
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </PersistGate>
      </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

